<template>
  <div class="app-container">
    <div class="course-resource-header">
      <h2>课程资料</h2>
    </div>

    <!-- 课程选择 -->
    <div class="course-selector">
      <el-select
        v-model="selectedCourseId"
        placeholder="请选择课程"
        @change="loadResources"
        style="width: 300px;"
      >
        <el-option
          v-for="course in courses"
          :key="course.id"
          :label="course.courseName"
          :value="course.id"
        />
      </el-select>
    </div>

    <!-- 资料列表 -->
    <div class="resource-list" v-if="selectedCourseId">
      <el-table
        :data="resources"
        v-loading="loading"
        style="width: 100%"
        empty-text="暂无资料"
      >
        <el-table-column prop="originalFileName" label="文件名" min-width="200">
          <template slot-scope="scope">
            <div class="file-info">
              <i :class="getFileIcon(scope.row.fileType)" class="file-icon"></i>
              <span>{{ scope.row.originalFileName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="description" label="描述" min-width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.description">{{ scope.row.description }}</span>
            <span v-else class="text-muted">暂无描述</span>
          </template>
        </el-table-column>

        <el-table-column prop="fileSize" label="文件大小" width="120">
          <template slot-scope="scope">
            {{ formatFileSize(scope.row.fileSize) }}
          </template>
        </el-table-column>

        <el-table-column prop="downloadCount" label="下载次数" width="100">
          <template slot-scope="scope">
            {{ scope.row.downloadCount || 0 }}
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="上传时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              @click="downloadResource(scope.row)"
            >
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <el-empty description="请选择课程查看资料"></el-empty>
    </div>
  </div>
</template>

<script>
import { getCourseResourceList, downloadCourseResource } from '@/api/courseResource'
import { getTeachCourseList } from '@/api/course'

export default {
  name: 'CourseResourceView',
  data() {
    return {
      courses: [],
      selectedCourseId: null,
      resources: [],
      loading: false
    }
  },

  mounted() {
    this.loadCourses()
  },

  methods: {
    // 加载课程列表
    async loadCourses() {
      try {
        const response = await getTeachCourseList()
        this.courses = response.data || []
      } catch (error) {
        this.$message.error('加载课程列表失败')
      }
    },

    // 加载资料列表
    async loadResources() {
      if (!this.selectedCourseId) return

      this.loading = true
      try {
        const response = await getCourseResourceList(this.selectedCourseId)
        this.resources = response.data || []
      } catch (error) {
        this.$message.error('加载资料列表失败')
      } finally {
        this.loading = false
      }
    },

    // 下载资料
    async downloadResource(resource) {
      try {
        const response = await downloadCourseResource(resource.id)

        // 创建下载链接
        const blob = new Blob([response])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = resource.originalFileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('下载成功')
        this.loadResources() // 刷新下载次数
      } catch (error) {
        this.$message.error('下载失败: ' + (error.message || '未知错误'))
      }
    },

    // 获取文件图标
    getFileIcon(fileType) {
      const iconMap = {
        'pdf': 'el-icon-document',
        'doc': 'el-icon-document',
        'docx': 'el-icon-document',
        'ppt': 'el-icon-present',
        'pptx': 'el-icon-present',
        'zip': 'el-icon-folder',
        'rar': 'el-icon-folder',
        '7z': 'el-icon-folder'
      }
      return iconMap[fileType] || 'el-icon-document'
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.course-resource-header {
  margin-bottom: 20px;
}

.course-selector {
  margin-bottom: 20px;
}

.resource-list {
  margin-top: 20px;
}

.file-info {
  display: flex;
  align-items: center;
}

.file-icon {
  margin-right: 8px;
  font-size: 16px;
  color: #409EFF;
}

.text-muted {
  color: #999;
}

.empty-state {
  margin-top: 50px;
}
</style>
